import { ActionTree } from "vuex";
import * as types from "../constants/ins_user_info_types";
import { goToLogin, showLiteSearch } from "@/utils/router_helper/index";
import { insLogin } from "@/services/ins_login/login_service";
import { router, Vue } from "@/main";
import { INS_LOGIN_MSG } from "@/api/ins/base/ins_res_const";
import {
  clearRoutes,
  findExactRoute,
  findRouteIndex,
  getCurrentRoute
} from "@/plugins/navigation/routes";
import { InsUserInfo } from "../modules/ins_user_info_module";
import { fb_login } from "@/services/fb_login";
import {
  GETTER_CURRENT_USER_MEDIA_LIST,
  SUPPLEMENT_INS_USER_MEDIA_LIST,
  UPDATE_CURRENT_POST_ID,
  UPDATE_INS_MEDIA_LIST_INFO,
  CLEAR_INS_USER_MEDIA_LIST
} from "@/store/constants/ins_media_types";
import { GETTER_INS_USER_INFO_BY_ID } from "@/store/constants/ins_user_info_types";
import LoginFromModule from "@/utils/router_helper/loginFromModule";
import Event_bus from "@/utils/event_bus";
import FreeFollowUtil from "@/services/free_follow";
import * as index_types from "@/store/constants/index_types";
import { LoginFromTypes } from "@/utils/router_helper/types";
import { isHasNotBindVip } from "@/utils/general_utils";
import paymentCheckModule from "@/services/payment/payment_check";
import { dialogBindVip, bindUserToVip } from "@/services/vip/vip_bind";
import {
  userInfoById,
  userInfoWithUsername
} from "@/api/ins_api_new/apis/ins_user";
import { twoFactorLogin } from "@/api/ins_api_new/apis/ins_towfactor";
import { bloksApps } from "@/api/ins_api_new/apis/ins_challenge";
import CGAPIBcloksPayload from "../../api/ins_api_new/utils/challenge_helper/block_payload";
import { act_users_action } from "@/services/earn_coins/observer/act_users_observer";

export const ins_user_info_factory = (data: any) => {
  return {
    profile_pic_url: data.profile_pic_url || "",
    is_private: data.is_private || false,
    user_name: data.username || "",
    full_name: data.full_name || "",
    follower_count: data.follower_count || 0,
    media_count: data.media_count || 0,
    has_anonymous_profile_picture: data.has_anonymous_profile_picture || false
  };
};

const actions: ActionTree<any, any> = {
  [types.SHOW_SEARCH_OR_LOGIN]({ getters }, from: LoginFromTypes) {
    // const currentUserId = getters[index_types.GETTER_CURRENT_USER_ID];
    const VerifyId = getters[types.GETTER_NOT_VERFY_USER_ID];
    if (VerifyId) {
      showLiteSearch(true);
    } else {
      goToLogin(from);
    }
  },

  async [types.LOGIN_BY_INS]({ dispatch }, payload) {
    try {
      const { username, password } = payload;
      const loginResult = await insLogin({
        username,
        password
      });
      console.log("ins loginResult:", loginResult);

      await dispatch(types.LOGIN_RES_RESOLVE, loginResult);
    } catch (error) {
      console.log("LOGIN_BY_INS error", error);
      return Promise.reject(error);
    }
  },
  async [types.LOGIN_BY_FB]({ dispatch }) {
    try {
      // open browser
      const fb_result: any = await fb_login();
      const { data } = fb_result;
      // loading to show ; hide :1.splash 2.login
      Vue.prototype.$_Toast.show({
        type: "loading",
        text: "Processing"
      });
      const loginResult = await insLogin({
        fbToken: data
      });
      Vue.prototype.$_Toast.hide();
      console.log("Fb loginResult:", loginResult);
      await dispatch(types.LOGIN_RES_RESOLVE, loginResult);
    } catch (error) {
      console.log("LOGIN_BY_FB error:", error);
      Vue.prototype.$_Toast.hide();
      dispatch(types.LOGIN_BY_FB_ERROR_TOAST, error);
      return Promise.reject(error);
    }
  },
  async [types.LOGIN_BY_FB_ERROR_TOAST]({}, payload: any) {
    const { status, data } = payload;
    if (status && data && data.message) {
      Vue.prototype.$_Toast.show({
        text: data.message
      });
      return;
    }
  },
  async [types.HANLDE_CHALLENGE]({ dispatch }, payload: any) {
    console.log("HANLDE_CHALLENGE payload", payload);
    const { login_user_id } = payload;
    const step_name = CGAPIBcloksPayload.getMethodWay();
    let pageType = "selectWay";
    try {
      if (
        step_name === "delta_login_review" ||
        step_name === "informational" ||
        step_name === "delta_acknowledge_approved" ||
        step_name === "review_contact_point_change"
      ) {
        const deltaActions = CGAPIBcloksPayload.preferredChallengeAction(
          "take_challenge"
        );
        if (deltaActions.error_type) {
          return Promise.reject(deltaActions);
        }
        const deltaResult = await bloksApps(deltaActions, login_user_id);
        if (deltaResult.status === INS_LOGIN_MSG.INS_LOGIN_SUCCESS) {
          dispatch(types.LOGIN_SUCCESS_RESOLVE, deltaResult.logged_in_user);
        }
        console.log("delta_login_review deltaResult", deltaResult);
        const methodsWay = CGAPIBcloksPayload.getMethodWay();
        if (methodsWay) {
          await dispatch(types.HANLDE_CHALLENGE, {
            step_name: methodsWay,
            login_user_id
          });
          return;
        } else {
          return Promise.reject({
            error_type: "show_toast",
            message:
              "Something is wrong with your account, please fix it in Instagram.",
            close_page: true
          });
        }
      } else if (
        step_name === "select_verify_method" ||
        step_name === "select_verification_method" ||
        step_name === "select_contact_point_recovery"
      ) {
        // 遇到select_contact_point_recovery会去选择输入验证方式的页面，然后去输入验证码的页面，再进入确认用户信息页面，点击这是我
      } else if (
        step_name === "verify_email" ||
        step_name === "verify_code" ||
        step_name === "verify_sms_code" ||
        step_name === "verify_email_code"
      ) {
        pageType = "SecurityCode";
      } else {
        // set_new_password 之类无法处理 的
        CGAPIBcloksPayload.clearChallengeParams();
        return Promise.reject({
          error_type: "show_toast",
          message:
            "Something is wrong with your account, please fix it in Instagram.",
          close_page: true
        });
      }
      router.push({
        name: "ChallengePage",
        query: {
          routerTransition: "forward",
          queryData: JSON.stringify(payload),
          pageType
        }
      });
    } catch (error) {
      console.log("HANLDE_CHALLENGE error", error);
    }
  },
  async [types.LOGIN_RES_RESOLVE]({ dispatch }, payload: any) {
    try {
      const { status, data } = payload;
      console.log("LOGIN_RES_RESOLVE payload", payload);

      if (status === INS_LOGIN_MSG.INS_LOGIN_SUCCESS) {
        dispatch(types.LOGIN_SUCCESS_RESOLVE, data);
        return;
      } else if (status === INS_LOGIN_MSG.INS_LOGIN_CHALLENGE_VERIFY) {
        // challenge_context, step_name;
        await dispatch(types.HANLDE_CHALLENGE, data);
        return;
      } else if (status === INS_LOGIN_MSG.INS_LOGIN_TWO_FACTOR) {
        router.push({
          name: "TwoFactorSecurityCode",
          query: {
            routerTransition: "forward",
            queryData: JSON.stringify(payload)
          }
        });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.INS_CHALLANGER_VERFIY_LOGIN]({ dispatch }, payload: any) {
    try {
      console.log("INS_CHALLANGER_VERFIY_LOGIN payload", payload);
      const { code } = payload;
      const methodsWay = CGAPIBcloksPayload.getMethodWay();
      if (
        methodsWay !== "verify_email" &&
        methodsWay !== "verify_code" &&
        methodsWay !== "verify_sms_code" &&
        methodsWay !== "verify_email_code"
      ) {
        await dispatch(types.HANLDE_CHALLENGE, {});
      } else {
        const takeAction = CGAPIBcloksPayload.preferredChallengeAction(
          "take_challenge"
        );
        takeAction.security_code = code;
        const blockResult = await bloksApps(takeAction);
        if (blockResult.status === INS_LOGIN_MSG.INS_LOGIN_SUCCESS) {
          const { status, logged_in_user, data }: any = blockResult;
          if (status === INS_LOGIN_MSG.INS_LOGIN_SUCCESS || status === "ok") {
            dispatch(types.LOGIN_SUCCESS_RESOLVE, logged_in_user || data);
            CGAPIBcloksPayload.clearChallengeParams();
          }
        } else {
          await dispatch(types.HANLDE_CHALLENGE, {});
        }
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.INS_TWOFACTORY_VERFIY_LOGIN]({ dispatch }, payload: any) {
    try {
      console.log("INS_TWOFACTORY_VERFIY_LOGIN payload", payload);
      const { securityCodeData, code } = payload;
      const loginResult = await twoFactorLogin(code, securityCodeData);
      const { status, data, logged_in_user } = loginResult;
      if (status === INS_LOGIN_MSG.INS_LOGIN_SUCCESS || status === "ok") {
        dispatch(types.LOGIN_SUCCESS_RESOLVE, data || logged_in_user);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.UPDATE_EARN_COINS_ACT_USER_INFO](
    { dispatch, getters },
    payload
  ) {
    //
    try {
      const { user_id, user_info, ins_media_list } = payload;
      let has_anonymous_profile_picture: any;
      let media_count: any;
      let ins_user_info;
      if (user_info) {
        // 更新user_info触发的
        ins_user_info = ins_user_info_factory(user_info);
        media_count = ins_user_info.media_count;
        has_anonymous_profile_picture =
          ins_user_info.has_anonymous_profile_picture;
      } else if (ins_media_list) {
        // 更新ins_media_list触发的
        ins_user_info = getters[GETTER_INS_USER_INFO_BY_ID];
        media_count = ins_media_list.length;
        has_anonymous_profile_picture =
          ins_user_info.has_anonymous_profile_picture;
      }

      if (has_anonymous_profile_picture || media_count === 0) {
        // need complete profile:
        act_users_action.trigger_act_need_complete_profile(user_id, true);
      } else {
        act_users_action.trigger_act_need_complete_profile(user_id, false);
      }
    } catch (error) {
      //
    }
  },
  async [types.FETCH_INS_USER_INFO]({ dispatch }, payload) {
    try {
      const { user_id, user_name } = payload;
      let ins_result: any = null;
      if (user_id) {
        ins_result = await userInfoById(user_id);
      } else {
        ins_result = await userInfoWithUsername(user_name);
      }
      console.log("FETCH_INS_USER_INFO result", ins_result);
      if (ins_result && ins_result.status === "ok") {
        // 在拉取用户信息的时候来改变当前act user的一些状态值:
        if (user_id) {
          // 是登陆类型的用户，判断是否和当前的earn coins的用户相同，则需要更新act_map里面的信息:
          dispatch(types.UPDATE_EARN_COINS_ACT_USER_INFO, {
            user_id,
            user_info: ins_result.user
          });
        }

        return ins_result.user;
      } else {
        return Promise.reject(ins_result);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.SEARCH_INS_USER]({ dispatch }, payload) {
    //
    try {
      const ins_result = await dispatch(types.FETCH_INS_USER_INFO, {
        user_name: payload
      });
      dispatch(types.ADD_INS_USER, {
        user_type: "search",
        data: ins_result
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.LOGIN_SUCCESS_RESOLVE]({ dispatch }, payload: any) {
    dispatch(types.ADD_INS_USER, {
      user_type: "login",
      data: payload
    });
  },
  async [types.SUPPLEMENT_INS_USER_INFO](
    { commit, dispatch },
    payload: string
  ) {
    // 补齐登陆用户的info的字段:
    try {
      // 更新user_info_list的值
      const user_id = payload;

      // 更新前改变拉取状态
      commit(types.UPDATE_INS_USER_INFO, {
        user_id,
        user_info: {
          fetch_status: "fetching",
          fetched: false // 是登陆过来补充的，需要改变默认字段
        }
      });

      const ins_result = await dispatch(types.FETCH_INS_USER_INFO, {
        user_id
      });

      // 更新成功改变状态
      commit(types.UPDATE_INS_USER_INFO, {
        user_id,
        user_info: {
          fetch_status: "idle",
          fetched: true,
          ins_user_info: {
            ...ins_user_info_factory(ins_result)
          }
        }
      });
    } catch (error) {
      //
      const user_id = payload;
      commit(types.UPDATE_INS_USER_INFO, {
        user_id,
        user_info: {
          fetch_status: "failed" // 补充失败
        }
      });
    }
  },
  async [types.ADD_INS_USER]({ commit, dispatch }, payload: any) {
    // 添加一个ins账号,login or search
    try {
      const { data, user_type } = payload;
      const user_id = data.pk.toString();

      // 改变当前用户 user id
      commit(index_types.UPDATE_CURRENT_USER_ID, user_id);
      // 增加用户list中的信息
      dispatch(types.ADD_INS_USER_INFO, {
        data,
        user_type
      });
      // 如果是登陆类型用户，信息不全，需要多一次fetch_ins_user_info的请求来补齐字段:
      if (user_type === "login") {
        dispatch(types.SUPPLEMENT_INS_USER_INFO, user_id);
      }

      // 不管是登陆还是非登录用户都需要静默补充账户的media_list:
      dispatch(SUPPLEMENT_INS_USER_MEDIA_LIST, {
        user_id
      });

      // 成功添加账号后的统一处理逻辑
      dispatch(types.HANDLE_ADD_USER_SUCCESS, {
        user_type,
        user_id
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.ADD_INS_USER_INFO]({ commit, dispatch }, payload: any) {
    try {
      const { data, user_type } = payload;
      const user_id = data.pk.toString();
      // 添加搜索类型的用户,获取到的data字段是健全的; 登陆用户的follower_count等字段没有，判断为非fetched的字段
      const user_info: InsUserInfo = {
        user_id,
        user_type,
        fetch_status: "idle",
        fetched: user_type === "login" ? false : true,
        ins_user_info: ins_user_info_factory(data)
      };
      // 更新user_info_list的值
      commit(types.ADD_INS_USER_INFO, {
        user_id,
        user_info,
        user_type
      });

      //  改变当前earn coins的user_id
      if (user_type === "login") {
        // 改变当前的earn coins user_id
        commit(index_types.UPDATE_CURRENT_EARN_COINS_USER_ID, user_id);
        act_users_action.add_new_act_user(user_id);
      }

      return user_info;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [index_types.CHANGE_CURRENT_INS_USER_ID](
    { dispatch, getters, commit },
    payload: string
  ) {
    try {
      // 改变用户id
      commit(index_types.UPDATE_CURRENT_USER_ID, payload);

      const current_media_list = getters[GETTER_CURRENT_USER_MEDIA_LIST];

      // 改变current post id :
      if (
        current_media_list &&
        current_media_list.ins_media_list &&
        current_media_list.ins_media_list[0]
      ) {
        commit(UPDATE_CURRENT_POST_ID, current_media_list.ins_media_list[0].id);
      } else {
        commit(UPDATE_CURRENT_POST_ID, null);
      }

      if (current_media_list && current_media_list.fetched === false) {
        // media list没有拉取成功过，需要再次拉取
        dispatch(SUPPLEMENT_INS_USER_MEDIA_LIST, { user_id: payload });
      }

      // 通知ins media list 改变：
      Event_bus.$emit("ins_media_list_change", {
        update_mode: "update",
        user_id: payload
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.REFRESH_CURRENT_INS_UNSR_INFO]({ dispatch, getters }) {
    try {
      const currentUserInfo = getters[types.GETTER_CURRENT_INS_USER_INFO];
      if (!currentUserInfo) {
        return;
      }
      const { user_id } = currentUserInfo;
      const ins_user_info = await dispatch(
        types.REFRESH_ONE_INS_USER_INFO,
        user_id
      );
      return ins_user_info;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.REFRESH_ONE_INS_USER_INFO]({ dispatch, commit }, payload) {
    try {
      if (!payload) {
        // 避免错误使用action来刷新不存在的用户
        return Promise.reject("Empty user id to refresh user info.");
      }
      const user_id = payload;
      commit(types.UPDATE_INS_USER_INFO, {
        user_id,
        user_info: {
          fetch_status: "fetching" // 不改变fetched的默认值，可能已经拉取成功过
        }
      });
      // 用登陆的api_by_id来刷新用户信息
      const ins_result = await dispatch(types.FETCH_INS_USER_INFO, {
        user_id
      });
      // 更新成功改变状态
      const ins_user_info = ins_user_info_factory(ins_result);
      commit(types.UPDATE_INS_USER_INFO, {
        user_id,
        user_info: {
          fetch_status: "idle",
          fetched: true,
          ins_user_info
        }
      });
      return ins_user_info;
    } catch (error) {
      // 不改变fetched的默认值，可能已经拉取成功过
      return Promise.reject(error);
    }
  },
  async [types.DELETE_INS_USER]({ dispatch, commit, state }, userInfo) {
    try {
      const { user_type, user_id } = userInfo;
      // 删除user_list中的用户:
      commit(types.DELETE_INS_USER_INFO, user_id);
      // 删除post_list
      commit(UPDATE_INS_MEDIA_LIST_INFO, {
        update_mode: "delete",
        user_id
      });

      if (user_type === "login") {
        // 登出的是登陆类型的用户
        const loggined_users = state.ins_user_info_list.filter((user: any) => {
          return user.user_type === "login";
        });
        if (loggined_users.length > 0) {
          // 还有登陆过的用户:
          const loggined_first_user_id = loggined_users[0].user_id;
          commit(
            index_types.UPDATE_CURRENT_EARN_COINS_USER_ID,
            loggined_first_user_id
          );
          // act_users_action.update_act_new_users_action(loggined_first_user_id);
        } else {
          // 没有登录过的用户,需要弹出登陆框，使用的请求都是需要登陆的,避免还有搜索用户存在,
          // 需要做强制登陆，或者登出所有的其他的搜索用户
          // 删除所有用户
          commit(index_types.UPDATE_CURRENT_EARN_COINS_USER_ID, null);
          // act_users_mutation.clear_current_act_user();
          // 删除所有的用户 info和media_list
          commit(CLEAR_INS_USER_MEDIA_LIST);
          commit(types.CLEAR_INS_USER_INFO);
        }
      }

      // 获取第一个用户的id
      const first_user_id =
        state.ins_user_info_list.length > 0
          ? state.ins_user_info_list[0].user_id
          : null;
      // 改变当前用户id和相关的media信息
      dispatch(index_types.CHANGE_CURRENT_INS_USER_ID, first_user_id);

      if (state.ins_user_info_list.length <= 0) {
        goToLogin();
      }
    } catch (error) {
      console.log("DELETE_INS_USER_INFO_BY_ID error", error);
    }
  },
  async [types.HANDLE_ADD_USER_SUCCESS](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const { user_type, user_id } = payload;

      if (user_type === "search") {
        // 通过搜索来添加用户
      } else {
        // 通过登录来添加用户
        if (getCurrentRoute().name !== "Home") {
          // 非home下才跳转，home页下不做任何跳转
          const findHomeIndex = findRouteIndex("Home");
          if (findHomeIndex > -1) {
            // 已经进入过home
            let routerBack = 0;
            const findLogin = findExactRoute("Login");
            findLogin && ++routerBack;
            const findSplash = findExactRoute("Splash");
            findSplash && ++routerBack;
            const findChallengeRequire = findExactRoute("ChallengeRequire");
            findChallengeRequire && ++routerBack;
            const findSecurityCode = findExactRoute("SecurityCode");
            findSecurityCode && ++routerBack;
            const findChallengePage = findExactRoute("ChallengePage");
            findChallengePage && ++routerBack;
            const findTwoFactorSecurityCode = findExactRoute(
              "TwoFactorSecurityCode"
            );
            findTwoFactorSecurityCode && ++routerBack;
            const loginFrom = LoginFromModule.getPlace();
            if (loginFrom === LoginFromTypes.FREE_FOLLOW) {
              // 有free follow，先关闭free follow 再返回,避免回到home页后闪现free follow
              Event_bus.$emit("is_show_free_follow", false);
              FreeFollowUtil.getFollower();
            } else if (loginFrom === LoginFromTypes.VIP) {
              // vip自动绑定的相关逻辑
              dialogBindVip();
            } else if (loginFrom === LoginFromTypes.BUY) {
              // 自动执行购买的 payment generator
              setTimeout(() => {
                paymentCheckModule.get().next();
              }, 0);
            } else if (isHasNotBindVip()) {
              // 如果有没有绑定的vip，直接绑定到当前账号
              bindUserToVip();
            }
            LoginFromModule.setPlace(null);
            router.go(-routerBack);
          } else {
            clearRoutes();
            router.replace({
              name: "Home",
              query: {
                routerTransition: "forward"
              }
            });
          }
        }
      }
    } catch (error) {
      console.log("HANDLE_ADD_USER_SUCCESS error", error);
      return Promise.reject(error);
    }
  }
};
export default actions;
